import React from 'react'
import {
  LookupNameColumn
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

export const IndividualsInCharge = React.memo(function IndividualsInCharge ({ dataSource }) {
  const { localize, locale } = useLocalization()
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.IndividualsInCharge}>
      <PropertyRenderer name='individualsInChargeOf' inputType='grid' dataSource={dataSource} readonly>
        {LookupNameColumn({ locale, field: 'individual', title: localize('Individuals.PersonName'), editable: false })}
        {LookupNameColumn({ locale, field: 'responsibilityType', title: localize('Individuals.Responsibility'), editable: false })}
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/individualsInCharge.js